import { matchPath } from 'react-router-dom';

type RedirectRule = {
  from: string;
  to: (params: Record<string, string | undefined>) => string;
};

const TO_METRICS_RULES: RedirectRule[] = [
  {
    from: '/results/:kitId/insights/all-insights',
    to: ({ kitId }) => `/results/${kitId}/metrics/all-metrics`,
  },
  {
    from: '/results/:kitId/insights/all-insights/:subMetricId',
    to: ({ kitId, subMetricId }) =>
      `/results/${kitId}/metrics/all-metrics/${subMetricId}`,
  },
  {
    from: '/results/:kitId/insights/:category/:subMetricId',
    to: ({ kitId, category, subMetricId }) =>
      `/results/${kitId}/metrics/${category}/${subMetricId}`,
  },
];

/**
 * Maps an old insights/* URL (emails, PDF reports, bookmarks) to its
 * metrics/* equivalent. Returns null when no redirect applies.
 */
export const getMetricsRedirectPath = (pathname: string): string | null => {
  for (const rule of TO_METRICS_RULES) {
    const match = matchPath(rule.from, pathname);
    if (match) return rule.to(match.params);
  }
  return null;
};
